import { Injectable } from '@angular/core';
import { EventsService } from 'src/app/core/services/events.service';

@Injectable({
  providedIn: 'root'
})
export class CoreMapLayerService extends EventsService {

  constructor() {
    super();
   }
}
